export const APPLICATION_DETAIL_SUCCESS = 'APPLICATION_DETAIL_SUCCESS';
export const APPLICATION_DETAIL_LOADING = 'APPLICATION_DETAIL_LOADING';
export const APPLICATION_DETAIL_FAILED = 'APPLICATION_DETAIL_FAILED';
export const APPLICATION_DETAIL_LOADDATA = 'APPLICATION_DETAIL_LOADDATA';
